import { Component, Input, OnInit } from "@angular/core";
import { DataService_StudentFinesDebts } from "../../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-fine-history-table",
	templateUrl: "./fine-history-table.component.html",
	styleUrls: ["./fine-history-table.component.css"],
})
export class FineHistoryTableComponent implements OnInit {
	constructor(private StudentFinesDebtsService: DataService_StudentFinesDebts) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.loadFine();
	}

	ngOnChanges() {
		this.loadFine();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SelectedPerson: any;
	@Input() Fine: any;

	isProcessing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedFine: any;
	lstFine: any = [];

	//Filter lists
	lstFineTypeDesc: any = [];
	lstPartOfGroupAction: any = [];
	lstTransactionType: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "FineDateDesc", header: "Date/Time" },
		{ field: "TransactionType", header: "TransactionType" },
		{ field: "FineTypeDesc", header: "Fine Type" },
		{ field: "AmountDesc", header: "Charged" },
		{ field: "WaivedDesc", header: "Adjusted" },
		{ field: "PaidDesc", header: "Paid" },
		{ field: "BalanceDesc", header: "Balance" },
		{ field: "FineComment", header: "Comments" },
		{ field: "PartOfGroupAction", header: "Part of Group Action" },
		{ field: "GroupName", header: "GroupName" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadFine() {
		this.loading = true;

		// console.log(this.Fine);

		if (this.SelectedPerson == undefined || this.Fine == undefined) {
			this.lstFine = [];
			this.lstFineTypeDesc = [];

			this.loading = false;

			return;
		}
		if (this.Fine.TransactionType == "D") {
			this.loadDebit();
		} else {
			this.loadCredit();
		}
	}

	loadDebit() {
		var result = this.StudentFinesDebtsService.LoadFineDetails(this.SelectedPerson.PersonID, this.Fine.FineID, -1);
		result.subscribe(
			(response) => {
				this.lstFine = response;

				for (var i = 0; i < this.lstFine.length; i++) {
					var next = this.lstFine[i];

					next.FineDateDesc = moment(new Date(next.FineDate)).format("MM/DD/YYYY h:mm a");
				}

				//Load Data Filter Lists
				this.lstFineTypeDesc = Array.from(new Set(this.lstFine.map((item: any) => item.FineTypeDesc))).sort();
				this.lstPartOfGroupAction = Array.from(new Set(this.lstFine.map((item: any) => item.PartOfGroupAction))).sort();
				this.lstTransactionType = Array.from(new Set(this.lstFine.map((item: any) => item.TransactionType))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	loadCredit() {
		var result = this.StudentFinesDebtsService.LoadFineDetails(this.SelectedPerson.PersonID, -1, this.Fine.FineID);
		result.subscribe(
			(response) => {
				this.lstFine = response;

				for (var i = 0; i < this.lstFine.length; i++) {
					var next = this.lstFine[i];

					next.FineDateDesc = moment(new Date(next.FineDate)).format("MM/DD/YYYY h:mm a");
				}

				//Load Data Filter Lists
				this.lstFineTypeDesc = Array.from(new Set(this.lstFine.map((item: any) => item.FineTypeDesc))).sort();
				this.lstPartOfGroupAction = Array.from(new Set(this.lstFine.map((item: any) => item.PartOfGroupAction))).sort();
				this.lstTransactionType = Array.from(new Set(this.lstFine.map((item: any) => item.TransactionType))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedFine = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedFine = null;
	}

	////////////////////////////////////////////
}
